const Table = ({ headers, data, renderRow, columnAlignments = [] }) => {
  headers = headers || [];
  const getAlignment = (index) => {
    if (columnAlignments[index]) return columnAlignments[index];
    return "center";
  };
  
  return (
    <div className="overflow-x-auto bg-white d shadow-md rounded-lg">
      <table className="min-w-full table-auto md:table-fixed text-sm">
        <thead className="bg-gray-100 dark:bg-black">
          <tr>
            {headers.map((header, index) => {
              const align = getAlignment(index);
              return (
                <th 
                  key={index} 
                  className={`py-2 px-4 font-semibold dark:text-white text-xs md:text-sm text-black whitespace-nowrap ${
                    align === "center" ? "text-center" : align === "right" ? "text-right" : "text-left"
                  }`}
                >
                  {header}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((item, index) => renderRow(item, index))
          ) : (
            <tr>
              <td colSpan={headers.length} className="py-2 px-4 dark:bg-gray-950 dark:text-white md:text-md text-sm text-center text-gray-500">
                No data available.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
